import React from 'react';
import categoriasJson from './brandsJson.js';

function BrandsIcons({ limit = categoriasJson.length } ) {
  return (
    <ol>
      {categoriasJson.slice(0, limit).map((cats) => {
        let img = `${process.env.PUBLIC_URL}/images/brands/${cats.alt}.webp`;
        return (
          <li key={cats.titulo}>
            <figure>
              <img width="100%" src={img} alt={cats.titulo} className={cats.alt} loading="lazy"></img>
            </figure>
          </li>
        );
      })}
    </ol>
  );
}

export default BrandsIcons;